<app-main-layout>
  <app-mailings-page></app-mailings-page>
</app-main-layout>
